import { useState, useEffect } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import PrivateRoutes from './components/PrivateRoutes';
import Login from "./pages/Login";
import Dashboard from './pages/Dashboard';
import PMerchantManagement from './pages/PMerchantManagement';
import AMerchantManagement from './pages/AMerchantManagement';
import Transactions from './pages/Transactions';
import SidebarNavigation from './components/SidebarNavigation';
import ProcessorManagement from './pages/ProcessorManagement';
import ServiceManagement from './pages/ServiceManagement';
import PTPReport from './pages/PTPReport';
import PTPManualUpdate from './pages/PTPManualUpdate';
import DashboardPayout from './pages/DashboardPayout';
import PayoutWallet from './pages/PayoutWallet';
import Passbook from './pages/Passbook';
import Reversal from './pages/Reversal';
import AddReseller from './pages/AddReseller';
import PayinWallet from './pages/PayinWallet';
import PayinWalletReport from './pages/PayinWalletReport';

export default function App(){

    const [auth, setAuth] = useState(false);

    // console.log(auth)

    useEffect(() => {
        sessionStorage.clear();
    },[])

    return (
            // <Router >
          <Router basename='/Admin'> 
            <main>
            {auth ? <SidebarNavigation setAuth={setAuth}/> : ''}
            <Routes>
                <Route path='/' element={<Login setAuth={setAuth} />} /> 
                <Route element={<PrivateRoutes auth={auth} />}>
                    <Route path='/dashboard' element={<Dashboard setAuth={setAuth} />} />
                    <Route path='/pendingmerchantmanagement' element={<PMerchantManagement  setAuth={setAuth}/>} />
                    <Route path='/approvedmerchantmanagement' element={<AMerchantManagement  setAuth={setAuth}/>} />
                    <Route path='/transactions' element={<Transactions  setAuth={setAuth} />} />
                    <Route path='/procmanagement' element={<ProcessorManagement  setAuth={setAuth}/>} />
                    <Route path='/servicemanagement' element={<ServiceManagement  setAuth={setAuth}/>} />
                    <Route path='/ptpreport' element={<PTPReport  setAuth={setAuth}/>} />
                    <Route path='/ptpmanualupdate' element={<PTPManualUpdate  setAuth={setAuth}/>} />
                    <Route path='/payoutDashboard' element={<DashboardPayout setAuth={setAuth}/>} />
                    <Route path='/passbook' element={<Passbook setAuth={setAuth}/>} />
                    <Route path='/payoutWallet' element={<PayoutWallet setAuth={setAuth}/>} />
                    <Route path='/payinWallet' element={<PayinWallet setAuth={setAuth}/>} />
                    <Route path='/payinWalletReport' element={<PayinWalletReport setAuth={setAuth}/>} />
                    <Route path='/reversal' element={<Reversal setAuth={setAuth}/>} />
                    <Route path='/addReseller' element={<AddReseller setAuth={setAuth}/>} />
                </Route>
            </Routes>
            </main>
        </Router>
    )
}